import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import { SimpleMapScreenshoter } from 'leaflet-simple-map-screenshoter';
import { downloadBlob } from 'helper/downloadFile';
import { RECENTER_CONTROL_CLASS } from '../RecenterControl';

export default function ImageDownloader({
  setOnDownload,
  filename,
  caption = '',
}: {
  setOnDownload: React.Dispatch<React.SetStateAction<() => void>>;
  filename: string;
  caption?: string;
}) {
  const map = useMap();
  const simpleMapScreenshoter = useRef<SimpleMapScreenshoter | null>(null);

  useEffect(() => {
    if (filename !== '' && simpleMapScreenshoter.current === null) {
      simpleMapScreenshoter.current = new SimpleMapScreenshoter({
        hidden: true,
        hideElementsWithSelectors: [
          '.leaflet-control-zoom',
          '.leaflet-control-attribution',
          `.${RECENTER_CONTROL_CLASS}`,
        ],
        captionOffset: 10,
      }).addTo(map);
    }

    setOnDownload(() => () => {
      simpleMapScreenshoter.current?.takeScreen('blob', { caption }).then((blob) => {
        downloadBlob(blob as Blob, filename);
      });
    });
  }, [simpleMapScreenshoter, map, setOnDownload, filename, caption]);

  return null;
}
